import { Typography } from '@material-ui/core'
import React from 'react'

export const PostGroupName = ({ post }) => {
    return post.group_id ? <Typography variant="subtitle1">Group name {post.group_name} owner {post.group_owner}</Typography> : null
}